<template>
  <v-container
    class="universal-form mt-15"
    :class="{ 'pdf-mode': isPdfMode }"
    v-if="!error"
    ref="container"
  >
    <v-row justify="center">
      <v-col cols="12">
        <h5 class="text-h5 font-weight-bold header mb-3" :class="{ 'text-center': currentForm?.alignTitle == 'center'}" :style="{ 'font-size': `${currentForm?.fontSize}!important` || '24px' }" v-html="renderedHtmlTitle"></h5>
      </v-col>
    </v-row>

  <div class="organization-info d-flex">
      <h3 class="font-weight-bold mb-6 subtitle">
        {{getOrgInn}}
      </h3>
      <p class="ml-5 font-weight-bold mb-6 subtitle">{{getOrgName}}</p>
    </div>
    <!-- <h5 class="font-weight-bold mb-6 areaName" v-if="currentForm?.areaName">
      {{ currentForm.areaName }}
    </h5> -->

    <div class="report-meta d-flex flex-wrap">

      <!-- ИНН СхП -->
      <div class="mb-4 areaName mr-5" v-if="!isPdfMode && isSubmittingForOtherOrg">
        <p>ИНН СхП</p>

        <div>
          <v-text-field
            v-model="inn"
            variant="outlined"
            density="compact"
            style="width: 200px;"
            :disabled="!!($route.query.instanceId)"
            :rules="[innRule]"
            :error-messages="innError ? [innError] : []"
            @update:model-value="v => {
              inn = String(v ?? '').replace(/\D/g, '');
              innError = null;
            }"
          />

          <v-btn 
            variant="outlined"
            density="compact"
            style="width: 150px"
            :disabled="!!($route.query.instanceId) || !isInnValid"
            @click="applyInn"
          >
            Применить
          </v-btn>
        </div>
      </div>

      <div class="mb-4 areaName mr-5" v-if="currentForm?.period">
        <p>Период отчета</p>
        <v-autocomplete 
          v-if="!isPdfMode"
          v-model="period" 
          variant="outlined" 
          density="compact" 
          width="300px" 
          placeholder="Период отчета"
          item-title="shortForm"
          item-value="id"
          :disabled="!!($route.query.instanceId)"
          :items="distionaryItems[currentForm?.period]"
        >
        </v-autocomplete>
        <p v-else-if="isPdfMode">{{ distionaryItems[currentForm?.period]?.find(el => el.id == period).shortForm || '' }}</p>
      </div>
<!-- Дата подачи отчета -->
    <div class="f mb-4 areaName mr-5" v-if="currentForm?.dateReport">
      <p>Дата подачи заявки</p>

      <p v-if="isPdfMode">{{ toDDMMYYYY(dateReport) }}</p>

      <div v-else>
        <v-text-field 
          readonly 
          :value="toDDMMYYYY(dateReport)" 
          variant="outlined"
          density="compact"
          :disabled="!!($route.query.instanceId)"
        />

        <v-btn 
          variant="outlined"
          density="compact"
          style="width: 150px"
          @click="dateDialog = true"
          :disabled="!!($route.query.instanceId)"
        >
          Выбрать дату
        </v-btn>

        <v-dialog v-model="dateDialog" max-width="340px">
          <v-card>
            <v-card-title class="text-h6">Выберите дату</v-card-title>
            <v-card-text>
              <v-date-picker v-model="tempDate" />
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn text @click="dateDialog = false">Отмена</v-btn>
              <v-btn text color="primary" @click="confirmDate">Ок</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>


    <!-- Текущий год -->
    <div class="f mb-4 areaName mr-5" v-if="currentForm?.currentYear">
      <p>Текущий год</p>

      <p v-if="isPdfMode">{{ toDDMMYYYY(currentYear) }}</p>

      <div v-else>
        <v-text-field
          readonly
          :value="currentYear ? toDDMMYYYY(currentYear) : ''"
          variant="outlined"
          density="compact"
          style="width: 150px"
          :disabled="!!($route.query.instanceId)"
        />

        <v-btn
          variant="outlined"
          density="compact"
          style="width: 150px"
          @click="currentYearDialog = true"
          :disabled="!!($route.query.instanceId)"
        >
          Выбрать дату
        </v-btn>

        <v-dialog v-model="currentYearDialog" max-width="340px">
          <v-card>
            <v-card-title class="text-h6">Выберите дату</v-card-title>
            <v-card-text>
              <v-date-picker
                v-model="tempCurrentYear"
              />
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn text @click="currentYearDialog = false">Отмена</v-btn>
              <v-btn text color="primary" @click="confirmCurrentYear">Ок</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <!-- Прошлый год (полная дата) -->
    <div class="f mb-4 areaName mr-5" v-if="currentForm?.lastYear">
      <p>Прошлый год</p>

      <p v-if="isPdfMode">{{ toDDMMYYYY(lastYear) }}</p>

      <div v-else>
        <v-text-field
          readonly
          :value="lastYear ? toDDMMYYYY(lastYear) : ''"
          variant="outlined"
          density="compact"
          style="width: 150px"
          :disabled="!!($route.query.instanceId)"
        />

        <v-btn
          variant="outlined"
          density="compact"
          style="width: 150px"
          @click="lastYearDialog = true"
          :disabled="!!($route.query.instanceId)"
        >
          Выбрать дату
        </v-btn>

        <v-dialog v-model="lastYearDialog" max-width="340px">
          <v-card>
            <v-card-title class="text-h6">Выберите дату</v-card-title>
            <v-card-text>
              <v-date-picker
                v-model="tempLastYear"
              />
            </v-card-text>

            <v-card-actions class="justify-end">
              <v-btn text @click="lastYearDialog = false">Отмена</v-btn>
              <v-btn text color="primary" @click="confirmLastYear">Ок</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div class="additional-fields f mb-4 areaName mr-5 d-flex flex-wrap" v-if="currentForm?.dateReport">

          <div v-if="currentForm?.fields?.length > 0" class="additional-fields__list d-flex">
            <div v-for="field in currentForm.fields" :key="field.name">
              <p class="ml-5">{{ field.name }}</p>
              <v-text-field 
                v-model="field.value"
                v-if="!isPdfMode"
                variant="outlined"
                density="compact"
                style="width: 200px;"
                class="ml-4"
                :disabled="field.disabled"
              />
              <p v-else>{{ field.value }}</p>
            </div>
          </div>

      </div>


    </div>

    <div class="mb-5" v-if="currentForm?.showSelectYear">
        <p class="year__label">Год</p>
        <v-select 
          width="150px"
          variant="outlined"
          density="compact"
          :items="years"/>
    </div>
    
    
    <v-btn
      v-if="currentForm?.leafletEnabled === true"
      class="map-button mb-5"
      prepend-icon="mdi-map-marker-outline"
      append-icon="mdi-arrow-right"
      elevation="4"
      rounded="lg"
      @click="mapDialog = true"
    >
      Открыть карту
    </v-btn>
    <div v-if="groupedSections?.length > 1">
      <v-tabs v-model="activeTab" background-color="primary" dark>
        <v-tab v-for="(group, i) in groupedSections" :key="'tab-' + i">
          {{ getTabTitle(group) }}
        </v-tab>
      </v-tabs>

      <v-tabs-window v-model="activeTab">
        <v-tabs-window-item
          v-for="(group, i) in groupedSections"
          :key="'item-' + i"
        >
          <div class="mt-10" v-for="(section, j) in group" :key="'sec-' + j">
            <custom-data-table
              v-if="section.type === 'table'"
              :headers="section.columns"
              :items="section.rows"
              :allItems="calcAllItems"
              :data="currentForm.data"
              :isPdfMode="isPdfMode"
              :currentForm="currentForm"
              @update:data="val => Object.assign(currentForm.data, val)"
              @update:dictionaries="val => Object.assign(distionaryItems, val)"
            />
            <DefaultForm
              v-else-if="section.type === 'form' && section?.fields?.length"
              :fields="section.fields"
              :data="currentForm.data"
              :currentForm="currentForm"
              @update:data="val => Object.assign(currentForm.data, val)"
              :section="section"
              :meta="meta"
              :json="json"
              :distionaryItems="distionaryItems"
              :readonlyStatuses="readonlyStatuses"
              :metaAttributesData="metaAttributesData"
              :object="object"
              :userInn="userInn"
              :isPdfMode="isPdfMode"
              @ongetMetaAttributes="refreshMetaAttributes"
              @updateObject="updateObject"
              @updateDictionary="updateDictionary"
              @saveIntoPlicanteObject="saveIntoPlicanteObject"
              @getValuesForManaged="getValuesForManaged"
              :distionaryItemsLength="distionaryItemsLength"
              :distionaryItemsOffSet="distionaryItemsOffSet"
            /> 
            <p v-else-if="section.type === 'form' && !section?.fields?.length">В данной форме нет полей</p>
          </div>
        </v-tabs-window-item>
      </v-tabs-window>
    </div>
    <div v-else>
      <div class="" v-for="(section, j) in groupedSections[0]" :key="'sec0-' + j">
        <custom-data-table
          v-if="section.type === 'table'"
          :headers="section.columns"
          :items="section.rows"
          :allItems="calcAllItems"
          :data="currentForm.data"
          @update:data="val => Object.assign(currentForm.data, val)"
          @update:dictionaries="val => Object.assign(distionaryItems, val)"
          :index="j"
          :currentForm="currentForm"
          :isPdfMode="isPdfMode"
        />
        <DefaultForm
          v-else-if="section.type === 'form' && section?.fields?.length"
          :fields="section.fields"
          :data="currentForm.data"
          :currentForm="currentForm"
          @update:data="val => Object.assign(currentForm.data, val)"
          :section="section"
          :meta="meta"
          :json="json"
          :isPdfMode="isPdfMode"
          :distionaryItems="distionaryItems"
          :readonlyStatuses="readonlyStatuses"
          :metaAttributesData="metaAttributesData"
          :object="object"
          :userInn="userInn"
          @updateObject="updateObject"
          @updateDictionary="updateDictionary"
          @saveIntoPlicanteObject="saveIntoPlicanteObject"
          @ongetMetaAttributes="refreshMetaAttributes"
          @getValuesForManaged="getValuesForManaged"
          :distionaryItemsLength="distionaryItemsLength"
          :distionaryItemsOffSet="distionaryItemsOffSet"
        />
        <p v-else-if="section.type === 'form' && !section?.fields?.length">В данной форме нет полей</p>
      </div>
          </div>
              <div v-if="currentForm?.files?.length > 0" class="report-files mt-5">
              <div v-for="field in currentForm.files" :key="field.name">
                <p class="ml-5">{{ field.name }}</p>
                <v-file-input 
                  v-model="field.value"
                  v-if="!isPdfMode" 
                  variant="outlined"
                  density="compact"
                  style="width: 200px;"
                  class="ml-4"
                  :multiple="field.multiple"
                  :accept="getFileAccept(field)"
                  :rules="getFileRules(field)"
                  @update:model-value="onFileChange(field)"
                />
                <p v-else>{{ field.value }}</p>
              </div>
          </div>
    <div class="report-actions d-flex justify-end mt-10" v-if="currentForm?.sections && currentForm?.sections[activeTab].type == 'table' && !isPdfMode">
    <v-btn @click="recallReport()" class="mr-5" color="teal-lighten-1" v-if="currentForm.recalledStatusId && $route.query.instanceId">Отозвать</v-btn>

      <v-btn v-if="currentForm?.['excel-name'] || currentForm?.['server-excel-name']" @click="fillExcel(false, false, false, true)" class="mr-5" color="teal-lighten-1">Скачать xlsx</v-btn>
      <v-btn v-else @click="onDownLoadPdf()" class="mr-5" color="teal-lighten-1">Скачать pdf</v-btn>
      
      <v-btn color="teal-lighten-1" class="mr-5" @click="saveIntoPlicanteObjectAndGetPdf(undefined, true)" :disabled="disabledSave() || loading">Сохранить</v-btn>

      <!-- <v-btn size="small" @click="wordToJson" class="mr-5 mt-1">Кнопка для парсинга ворда</v-btn> -->

      <template v-if="groupedSections?.length > 1">
        <v-btn
          :style="{ visibility: activeTab > 0 ? 'visible' : 'hidden' }"
          :tabindex="activeTab > 0 ? 0 : -1"
          color="teal-lighten-1"
          class="mr-3"
          @click="activeTab--"
        >
          Назад
        </v-btn>

        <v-btn
          :style="{ visibility: activeTab < groupedSections.length - 1 ? 'visible' : 'hidden' }"
          :tabindex="activeTab < groupedSections.length - 1 ? 0 : -1"
          color="teal-lighten-1"
          class="mr-3"
          @click="activeTab++"
        >
          Далее
        </v-btn>
      </template>

      <v-btn
        v-if="currentForm?.withoutSig"
        color="teal-lighten-1"
        class="mr-5"
        @click="onClickUpload()"
        :disabled="!isLastTab || disabledSave() || loading"
      >
        Отправить
      </v-btn>
      <v-btn
        v-else
        color="teal-lighten-1"
        class="mr-5"
        @click="onClickSign()"
        :disabled="!isLastTab || disabledSave() || loading"
      >
        Подписать и отправить
      </v-btn>

      <!-- <v-btn color="teal-lighten-1" @click="onChangeStatus()" class="mr-5">Перевести в стутус (тест)</v-btn> -->
    </div>

    <v-container v-else-if="!currentForm?.sections || !currentForm?.sections[activeTab]?.type">
      <v-alert text="Невалидная форма"></v-alert>
    </v-container>
  </v-container>
  <v-container v-else>
     <v-alert :text="errorMessage" class="mt-15"></v-alert>
   </v-container>
   <v-dialog v-model="selectCertDialog" max-width="600px">
  <v-card>
    <v-card-title class="text-h6">
      Выберите сертификат
    </v-card-title>

    <v-card-text>
      <v-list density="compact" nav>
        <v-list-item
          v-for="cert in certList"
          :key="cert.thumbprint"
          @click="onSelectCert(cert)"
          class="cursor-pointer"
        >
          <v-list-item-title>
            {{ cert.subject }}
          </v-list-item-title>

          <v-list-item-subtitle
            :class="new Date(cert.validTo) > new Date() ? 'cert-valid' : 'cert-invalid'"
            class="d-flex align-center ga-1"
          >
            <v-icon size="16">
              {{
                new Date(cert.validTo) > new Date()
                  ? 'mdi-check-circle'
                  : 'mdi-close-circle'
              }}
            </v-icon>

            {{
              new Date(cert.validTo) > new Date()
                ? 'Действителен'
                : 'Просрочен'
            }}:
            {{ cert.validFrom }} — {{ cert.validTo }}
          </v-list-item-subtitle>

          <v-list-item-subtitle class="text-caption">
            Отпечаток: {{ cert.thumbprint }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn variant="text" @click="selectCertDialog = false">Закрыть</v-btn>
    </v-card-actions>
  </v-card>
    </v-dialog>
    <v-dialog
      v-model="mapDialog"
      max-width="1000"
      @after-enter="initMap"
      @after-leave="destroyMap"
    >
      <v-card class="map-dialog-card" rounded="xl">
        <v-card-title class="map-dialog-header d-flex align-center">
          <v-icon class="mr-3" color="teal-darken-1">mdi-map-marker-radius-outline</v-icon>
          <span>Карта</span>
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            aria-label="Закрыть карту"
            @click="mapDialog = false"
          />
        </v-card-title>

        <div class="map-search px-4 py-3">
          <div class="d-flex align-center ga-2">
            <v-text-field
              v-model="addressSearchQuery"
              class="map-search__field"
              label="Адрес"
              placeholder="Например: Москва, Тверская улица, 1"
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :disabled="addressSearchLoading"
              @keydown.enter.prevent="searchAddress"
            />
            <v-btn
              class="map-search__button"
              color="teal-darken-1"
              variant="flat"
              prepend-icon="mdi-map-search-outline"
              :loading="addressSearchLoading"
              :disabled="!addressSearchQuery?.trim()"
              @click="searchAddress"
            >
              Найти
            </v-btn>
          </div>
          <div v-if="addressSearchError" class="map-search__error mt-2">
            {{ addressSearchError }}
          </div>
        </div>

        <div class="map-toolbar d-flex align-center flex-wrap ga-2 px-4 py-3">
          <div class="map-stat">
            <span class="map-stat__label">Точек</span>
            <strong>{{ mapPoints.length }}</strong>
          </div>
          <div class="map-stat">
            <span class="map-stat__label">Площадь</span>
            <strong>{{ formattedMapArea }}</strong>
          </div>
          <v-spacer />
          <v-btn
            prepend-icon="mdi-undo"
            variant="tonal"
            color="teal-darken-1"
            :disabled="!mapPoints.length"
            @click="removeLastMapPoint"
          >
            Отменить точку
          </v-btn>
          <v-btn
            prepend-icon="mdi-delete-outline"
            variant="text"
            color="red-darken-1"
            :disabled="!mapPoints.length"
            @click="clearMapPoints"
          >
            Очистить
          </v-btn>
        </div>

        <v-card-text class="pa-0">
          <div ref="leafletMap" class="leaflet-map" />
        </v-card-text>
        <div class="map-hint px-4 py-2">
          Нажимайте на карту, чтобы добавить вершины участка. Готовую точку можно перетащить. Для расчёта площади нужно минимум три точки.
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" :color="color">
      {{ text }}
    </v-snackbar>

</template>

<script>
import CustomDataTable from './CustomDataTable.vue';
// import forms from '../forms'
import html2pdf from 'html2pdf.js'
import DefaultForm from './DefaultForm.vue';
import requestService from '@/services/request.service';
import JSZip from 'jszip'
import { mapGetters } from 'vuex'
// import * as XLSX from "xlsx"
import ExcelJS from "exceljs"
import plicanteRequestService from '@/services/plicante.request.service';
import { getCertificates, signFileWithCert } from '@/services/cryptoSignService'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import turfArea from '@turf/area'
import { polygon as turfPolygon } from '@turf/helpers'

export default {
  components: {
    CustomDataTable,
    DefaultForm
  },
  data() {
    return {
      required: value => !!value || 'Это поле обязательно',
      form: null,
      isFormValid: false,
      loadedValue: 'Подтянутое значение', 
      currentForm: null,
      currentFormDefaultData: null,
      activeTab: 0,
      years: ['2021', '2022', '2023', '2024', '2025'],
      error: false,
      errorMessage: 'Ошибка загрузки формы',
      parsedTables: null,
      json: null, 
      xlsx: null,
      meta: null,
      inn: null,
      enteredInn: null,
      enteredInnName: null,
      innError: null,
      period: null,
      readonlyStatuses: null,
      metaAttributesData: [],
      distionaryItems: {},
      object: null,
      offSet: 0,
      distionaryItemsLength: {},
      distionaryItemsOffSet: {},
      userInn: null,
      isPdfMode: false,
      dateReport: new Date(),
      dateDialog: false,
      yearDialog: false,
      tempDate: null,
      tempYearDate: null,
      currentYear: new Date(),
      lastYear: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
      currentYearDialog: false,
      lastYearDialog: false,
      selectedThumbprint: null,
      tempCurrentYear: null,
      tempLastYear: null,
      certList: [],
      selectedCert: null,
      selectCertDialog: false,
      mapDialog: false,
      mapPoints: [],
      mapAreaSquareMeters: 0,
      addressSearchQuery: '',
      addressSearchLoading: false,
      addressSearchError: '',
      snackbar: false,
      color: 'green',
      fullMeta: [],
      text: '',
      loading: false,
      correctSend: false,
      metaAttributesRequest: null,
      metaAttributesRequestKey: null,
      metaAttributesLoadedKey: null
    };
  },
  methods: {
    initMap() {
      if (this._leafletMap || !this.$refs.leafletMap) return

      this._leafletMap = L.map(this.$refs.leafletMap).setView([55.751244, 37.618423], 10)
      this._leafletMap.attributionControl.setPrefix(false)

      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this._leafletMap)

      this._mapShapeLayer = L.layerGroup().addTo(this._leafletMap)
      this._mapMarkersLayer = L.layerGroup().addTo(this._leafletMap)
      this._leafletMap.on('click', this.addMapPoint)
      this.renderMapGeometry()

      window.setTimeout(() => {
        this._leafletMap?.invalidateSize()
        this.fitMapToPoints()
      }, 0)
    },
    addMapPoint(event) {
      this.mapPoints.push({ lat: event.latlng.lat, lng: event.latlng.lng })
      this.renderMapGeometry()
    },
    async searchAddress() {
      const query = this.addressSearchQuery?.trim()
      if (!query || this.addressSearchLoading || !this._leafletMap) return

      this.addressSearchLoading = true
      this.addressSearchError = ''

      try {
        this._geocodingCache ||= new Map()
        const cacheKey = query.toLocaleLowerCase('ru-RU')
        let result = this._geocodingCache.get(cacheKey)

        if (!result) {
          const elapsed = Date.now() - (this._lastGeocodingRequestAt || 0)
          if (elapsed < 1000) {
            await new Promise(resolve => window.setTimeout(resolve, 1000 - elapsed))
          }

          const endpoint = process.env.VUE_APP_NOMINATIM_URL || 'https://nominatim.openstreetmap.org/search'
          const url = new URL(endpoint)
          url.searchParams.set('q', query)
          url.searchParams.set('format', 'jsonv2')
          url.searchParams.set('limit', '1')
          url.searchParams.set('addressdetails', '1')
          url.searchParams.set('accept-language', 'ru')

          this._lastGeocodingRequestAt = Date.now()
          const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' }
          })
          if (!response.ok) throw new Error(`Geocoding request failed: ${response.status}`)

          const results = await response.json()
          result = results[0] || null
          if (result) this._geocodingCache.set(cacheKey, result)
        }

        if (!result) {
          this.addressSearchError = 'Адрес не найден. Попробуйте уточнить запрос.'
          return
        }

        const lat = Number(result.lat)
        const lng = Number(result.lon)
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          throw new Error('Invalid coordinates received from geocoder')
        }

        if (this._searchResultMarker) this._searchResultMarker.remove()
        this._searchResultMarker = L.circleMarker([lat, lng], {
          radius: 9,
          color: '#ffffff',
          weight: 3,
          fillColor: '#00897b',
          fillOpacity: 1,
          bubblingMouseEvents: false
        }).addTo(this._leafletMap)

        const addressLabel = document.createElement('span')
        addressLabel.textContent = result.display_name
        this._searchResultMarker
          .bindPopup(addressLabel, { maxWidth: 320 })
          .openPopup()

        this._leafletMap.setView([lat, lng], 17)
      } catch (error) {
        console.error('Ошибка поиска адреса:', error)
        this.addressSearchError = 'Не удалось выполнить поиск. Попробуйте ещё раз.'
      } finally {
        this.addressSearchLoading = false
      }
    },
    removeLastMapPoint() {
      this.mapPoints.pop()
      this.renderMapGeometry()
    },
    clearMapPoints() {
      this.mapPoints = []
      this.renderMapGeometry()
    },
    calculateMapArea() {
      if (this.mapPoints.length < 3) {
        this.mapAreaSquareMeters = 0
        return
      }

      const ring = this.mapPoints.map(point => [point.lng, point.lat])
      ring.push([...ring[0]])
      this.mapAreaSquareMeters = turfArea(turfPolygon([ring]))
    },
    renderMapGeometry() {
      this.calculateMapArea()
      this.syncMapPointsToForm()
      if (!this._mapShapeLayer || !this._mapMarkersLayer) return

      this._mapMarkersLayer.clearLayers()
      this.renderMapShape()
      const latLngs = this.mapPoints.map(point => [point.lat, point.lng])

      latLngs.forEach((latLng, index) => {
        const marker = L.marker(latLng, {
          draggable: true,
          autoPan: true,
          icon: L.divIcon({
            className: 'map-point-marker',
            html: `<span>${index + 1}</span>`,
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          })
        })

        marker.on('drag', event => {
          const position = event.target.getLatLng()
          this.mapPoints[index] = { lat: position.lat, lng: position.lng }
          this.calculateMapArea()
          this.syncMapPointsToForm()
          this.renderMapShape()
        })
        marker.on('click', event => {
          L.DomEvent.stopPropagation(event.originalEvent)
          this.openDeletePointPopup(marker, index)
        })

        marker.addTo(this._mapMarkersLayer)
      })
    },
    openDeletePointPopup(marker, index) {
      const content = document.createElement('div')
      content.className = 'map-delete-popup'

      const question = document.createElement('div')
      question.className = 'map-delete-popup__question'
      question.textContent = `Удалить точку №${index + 1}?`

      const actions = document.createElement('div')
      actions.className = 'map-delete-popup__actions'

      const cancelButton = document.createElement('button')
      cancelButton.type = 'button'
      cancelButton.className = 'map-delete-popup__button map-delete-popup__button--cancel'
      cancelButton.textContent = 'Нет'
      cancelButton.addEventListener('click', () => this._leafletMap?.closePopup())

      const deleteButton = document.createElement('button')
      deleteButton.type = 'button'
      deleteButton.className = 'map-delete-popup__button map-delete-popup__button--delete'
      deleteButton.textContent = 'Удалить'
      deleteButton.addEventListener('click', () => {
        this.mapPoints.splice(index, 1)
        this.renderMapGeometry()
      })

      actions.append(cancelButton, deleteButton)
      content.append(question, actions)
      L.popup({
        closeButton: false,
        offset: [0, -8],
        className: 'map-delete-leaflet-popup'
      })
        .setLatLng(marker.getLatLng())
        .setContent(content)
        .openOn(this._leafletMap)
    },
    renderMapShape() {
      if (!this._mapShapeLayer) return

      this._mapShapeLayer.clearLayers()
      const latLngs = this.mapPoints.map(point => [point.lat, point.lng])

      if (latLngs.length >= 3) {
        L.polygon(latLngs, {
          color: '#00897b',
          weight: 3,
          fillColor: '#26a69a',
          fillOpacity: 0.24
        }).addTo(this._mapShapeLayer)
      } else if (latLngs.length >= 2) {
        L.polyline(latLngs, { color: '#00897b', weight: 3 }).addTo(this._mapShapeLayer)
      }
    },
    syncMapPointsToForm() {
      if (!this.currentForm) return

      this.currentForm.points = this.mapPoints.map(point => ({
        lat: point.lat,
        lng: point.lng
      }))
    },
    buildFormJsonPayload(form = this.currentForm) {
      if (!form) return form

      const payload = {}
      const points = this.mapPoints.map(point => ({
        lat: point.lat,
        lng: point.lng
      }))

      Object.entries(form).forEach(([key, value]) => {
        if (key === 'points') return

        payload[key] = value
        if (key === 'data') payload.points = points
      })

      if (!Object.prototype.hasOwnProperty.call(payload, 'points')) {
        payload.points = points
      }

      return payload
    },
    getMapGeometry() {
      return {
        points: this.mapPoints.map(point => ({ ...point })),
        areaSquareMeters: this.mapAreaSquareMeters
      }
    },
    restoreMapPoints(points, fitBounds = true) {
      this.mapPoints = (Array.isArray(points) ? points : [])
        .map(point => Array.isArray(point)
          ? { lat: Number(point[0]), lng: Number(point[1]) }
          : { lat: Number(point.lat), lng: Number(point.lng) })
        .filter(point => Number.isFinite(point.lat) && Number.isFinite(point.lng))

      this.syncMapPointsToForm()
      this.renderMapGeometry()

      if (fitBounds) this.fitMapToPoints()
    },
    fitMapToPoints() {
      if (!this._leafletMap || !this.mapPoints.length) return

      this._leafletMap.fitBounds(
        this.mapPoints.map(point => [point.lat, point.lng]),
        { padding: [40, 40], maxZoom: 16 }
      )
    },
    destroyMap() {
      if (!this._leafletMap) return

      this._leafletMap.off('click', this.addMapPoint)
      this._leafletMap.remove()
      this._leafletMap = null
      this._mapShapeLayer = null
      this._mapMarkersLayer = null
      this._searchResultMarker = null
    },
    isTableCellDisabled(cell) {
      if (cell?.disabled) return true
      if (!cell?.enabledWhen) return false

      const condition = cell.enabledWhen
      const selectedValue = this.currentForm?.data?.[condition.field]
      if (condition.itemId !== undefined) {
        const selectedItem = (this.distionaryItems[condition.code] || [])
          .find(item => item.shortForm === selectedValue)
        return String(selectedItem?.id) !== String(condition.itemId)
      }

      return selectedValue !== condition.value
    },
    innRule(v) {
      if (!v) return true
      if (!/^\d{10}$|^\d{12}$/.test(v)) {
        return 'Введите 10 или 12 цифр'
      }
      return true
    },
    async applyInn() {
      const org = await this.getOrgByInnByUserDistricts(this.inn)

      if (!org) {
        this.innError = 'ИНН не найден'
        this.userInn = null
        this.enteredInn = null
        this.enteredInnName = null
        return
      }

      this.userInn = org
      this.enteredInn = this.inn
      this.enteredInnName = org.attributeValueTypes
          ?.find(attr => attr.id === 543)
          ?.value
          ?.dataList?.[0]
          ?.data ?? ''

      if (this.currentForm.findFirst) {
          this.getFirstOfType()
        }
    },
    getFileAccept(file) {
      return file.multiple
        ? '.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.jpeg,.jpg,.kml'
        : '.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar'
    },
    validateFileValue(field) {
      if (!field?.value) return true

      const isMultiple = field.multiple

      const maxSize = isMultiple
        ? 10 * 1024 * 1024 * 1024
        : 100 * 1024 * 1024

      const allowedExtensions = isMultiple
        ? ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar', 'jpeg', 'jpg', 'kml']
        : ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']

      const files = Array.isArray(field.value)
        ? field.value
        : [field.value]

      return files.every(file => {
        if (!(file instanceof File || file instanceof Blob)) return true

        const extension = file.name?.split('.').pop()?.toLowerCase()

        return (
          file.size <= maxSize &&
          allowedExtensions.includes(extension)
        )
      })
    },
    onFileChange(field) {
      if (this.validateFileValue(field)) return

      field.value = field.multiple ? [] : null

      this.snackbar = true
      this.color = 'red'
      this.text = field.multiple
        ? 'Файлы должны быть до 10 Гб. Форматы: .pdf, .doc, .docx, .xls, .xlsx, .zip, .rar, .jpeg, .jpg, .kml'
        : 'Файл должен быть до 100 Мб. Форматы: .pdf, .doc, .docx, .xls, .xlsx, .zip, .rar'
    },
    getFileRules(file) {
      const isMultiple = file.multiple

      const maxSize = isMultiple
        ? 10 * 1024 * 1024 * 1024
        : 100 * 1024 * 1024

      const allowedExtensions = isMultiple
        ? ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar', 'jpeg', 'jpg', 'kml']
        : ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']

      return [
        (value) => {
          if (!value || value.length === 0) return true

          const files = Array.isArray(value) ? value : [value]

          const invalidSizeFile = files.find((item) => item.size > maxSize)

          if (invalidSizeFile) {
            return isMultiple
              ? 'Размер каждого файла не должен превышать 10 Гб'
              : 'Размер файла не должен превышать 100 Мб'
          }

          const invalidFormatFile = files.find((item) => {
            const extension = item?.name?.split('.').pop()?.toLowerCase()
            return !allowedExtensions.includes(extension)
          })

          if (invalidFormatFile) {
            return isMultiple
              ? 'Допустимые форматы: .pdf, .doc, .docx, .xls, .xlsx, .zip, .rar, .jpeg, .jpg, .kml'
              : 'Допустимые форматы: .pdf, .doc, .docx, .xls, .xlsx, .zip, .rar'
          }

          return true
        }
      ]
    },
    recallReport() {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/changeObjectStatus`;
      const payload = {
        "newStatusId": this.currentForm.recalledStatusId,
        "objectId": +(this.$route.query.instanceId),
        "oldStatusId": this.object.objectStatusesType.id
      }
      plicanteRequestService.post(url, payload)
      .then(() => {
        this.snackbar = true
        this.color = 'green'
        this.text = 'Отчет успешно отозван'
      })
      .catch(() => {
        this.snackbar = true
        this.color = 'red'
        this.text = 'Ошибка при отзыве отчета'
      })
    },
    toTimestamp(date) {
      if (!date) return null

      const d = new Date(date)

      return Date.UTC(
        d.getFullYear(),
        d.getMonth(),
        d.getDate()
      )
    },
    disabledSave() {
      const statusAllowed =
        !this.$route?.query?.dataId ||
        !this.currentForm.activeWithStatuses ||
        this.currentForm?.activeWithStatuses?.includes(this.object?.objectStatusesType?.id)
      
      
      const innDefined = !this.isSubmittingForOtherOrg || !!this.getOrgInn
      // Формы parkReports2 и parkReports3 отправляются с getOrgInn == null,
      // поэтому проверяем ИНН только при подаче за другую организацию

      return !(
        statusAllowed &&
        this.allRequiredTableFieldsFilled &&
        this.allRequiredFilesFilled &&
        this.allFilesValid &&
        innDefined
      )
    },
    onClickUpload() {
      this.loading = true
      this.saveIntoPlicanteObjectAndGetPdf(true, true)
    },
    onChangeStatus(id) {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/changeObjectStatus`;
      const payload = {
        "newStatusId": this.currentForm.statusId,
        "objectId": +(this.$route.query.instanceId) || id,
        "oldStatusId": this.object.objectStatusesType.id
      }
      plicanteRequestService.post(url, payload)
    },
    async waitForPdfLayout() {
      await this.$nextTick()

      await new Promise(resolve => {
        requestAnimationFrame(() => requestAnimationFrame(resolve))
      })
    },
    async onDownLoadPdf() {
      this.isPdfMode = true
      await this.waitForPdfLayout()

      const element = this.$refs.container?.$el || this.$refs.container
      if (!element) {
        this.isPdfMode = false
        return
      }

      const wrappers = element.querySelectorAll('.v-table__wrapper')
      const prevStyles = Array.from(wrappers).map(el => ({
        overflow: el.style.overflow,
        maxHeight: el.style.maxHeight
      }))

      wrappers.forEach(el => {
        el.style.overflow = 'visible'
        el.style.maxHeight = 'none'
      })

      await this.waitForPdfLayout()

      const pxPerMm = 96 / 25.4
      const a4PortraitWidthPx = 210 * pxPerMm
      const isLandscape = element.scrollWidth > a4PortraitWidthPx

      const options = {
        margin: 0,
        filename: this.getPdfName,
        image: { type: 'jpeg', quality: 1 },
        pagebreak: { mode: ['legacy'] },
        html2canvas: {
          scale: 4,
          useCORS: true,
          logging: false,
          scrollX: 0,
          scrollY: 0,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: isLandscape ? 'landscape' : 'portrait'
        }
      }

      try {
        await html2pdf().set(options).from(element).save()
      } finally {
        wrappers.forEach((el, i) => {
          el.style.overflow = prevStyles[i].overflow || ''
          el.style.maxHeight = prevStyles[i].maxHeight || ''
        })
        this.isPdfMode = false
      }
    },
    async onClickSign() {

      try {
        // 1. ждём инициализации CryptoPro
        const certificates  = await getCertificates()

        if (!certificates?.length) {
          alert("Нет доступных сертификатов")
          return
        }

        // 2. выбираем первый сертификат
        this.certList = certificates

        // открываем диалог с выбором сертификата
        this.selectCertDialog = true


        // 3. запускаем твой текущий функционал
        // await this.subscribeForm()

      } catch (e) {
        console.error("Ошибка подписи:", e)
        alert("Ошибка подписи: " + (e?.message ?? String(e)));
      }

    },
    onSelectCert(cert) {
      this.selectedThumbprint = cert.thumbprint
      this.selectCertDialog = false

      this.subscribeForm()
    },
    async saveIntoPlicanteObjectAndGetPdf(send, disabledSave) {
      await this.fillCurrentFormOrgInfo()
      
      this.loading = true
      if (!this.currentForm['excel-name'] && !this.currentForm['server-excel-name']) {
        this.isPdfMode = true;
        await this.waitForPdfLayout()

        const element = this.$refs.container?.$el || this.$refs.container
        const options = {
          margin: 0,
          filename: this.getPdfName,
          image: { type: 'jpeg', quality: 1 },
          pagebreak: { mode: ['legacy'] },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: false,
            scrollX: 0,
            scrollY: 0,
            windowWidth: element.scrollWidth,
            windowHeight: element.scrollHeight
          },
          jsPDF: {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait'
          }
        }

        const pdfWorker = html2pdf()
        .set(options)
        .from(element)

        // Blob
        const pdfBlob = await pdfWorker.outputPdf('blob');

        // Base64
        const pdfBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]);
          reader.onerror = reject;
          reader.readAsDataURL(pdfBlob);
        });

        // Download — используем тот же worker
        //dfWorker.save();

        this.isPdfMode = false;
        if (!disabledSave) {
          const a = document.createElement('a')
          a.href = URL.createObjectURL(pdfBlob)
          a.download = this.getPdfName
          a.click()
          URL.revokeObjectURL(a.href)
        }
        this.saveIntoPlicanteObject(false, pdfBase64, undefined, undefined, undefined, send);
      } else {
        this.fillExcel(false, true, send)
      }
    },
    async subscribeForm() { 
      await this.fillCurrentFormOrgInfo()

      if (!this.currentForm['excel-name'] && !this.currentForm['server-excel-name']) {
        this.isPdfMode = true;
        await this.waitForPdfLayout()

        const element = this.$refs.container?.$el || this.$refs.container
        const options = {
          margin: 0,
          filename: this.getPdfName,
          image: { type: 'jpeg', quality: 1 },
          pagebreak: { mode: ['legacy'] },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: false,
            scrollX: 0,
            scrollY: 0,
            windowWidth: element.scrollWidth,
            windowHeight: element.scrollHeight
          },
          jsPDF: {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait'
          }
        }

        const pdfWorker = html2pdf()
        .set(options)
        .from(element)

        // Blob
        const pdfBlob = await pdfWorker.outputPdf('blob');

        // Base64
        const pdfBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]);
          reader.onerror = reject;
          reader.readAsDataURL(pdfBlob);
        });

        // Download — используем тот же worker
        await pdfWorker.save();

        this.isPdfMode = false;
        const a = document.createElement('a')
        a.href = URL.createObjectURL(pdfBlob)
        a.download = this.getPdfName
        a.click()
        URL.revokeObjectURL(a.href)
        this.saveIntoPlicanteObject(true, pdfBase64);
      } else {
        this.fillExcel(true)
      }
    },
    getValuesForManaged(id, code) {
      const meta = this.metaAttributesData.find(el => el.code == code);
      this.getItemsForDictionary(meta, meta.code, 0, id)
    },
    toDDMMYYYY(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    getYear(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      return year;
    },
    confirmDate() {
      this.dateReport = this.tempDate;
      this.dateDialog = false;
    },
    confirmCurrentYear() {
      this.currentYear = this.tempCurrentYear

      const date = new Date(this.currentYear)

      const last = new Date(date)
      last.setFullYear(date.getFullYear() - 1)

      this.lastYear = last.toISOString()

      this.currentYearDialog = false
    },
    confirmLastYear() {
      this.lastYear = this.tempLastYear
      this.lastYearDialog = false
    },
    async formPdf() {
      this.saveIntoPlicanteObject(null, true)
    },
    async getOrgByInn(searchInn, districtRoles = []) {
      if (!searchInn) return null

      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`

      const filters = [
        {
          attribute: {
            id: 545,
            code: 'inn',
            dataType: 'STRING',
            attributeType: 'STRING',
            name: 'ИНН',
            search: true,
            multiple: false,
            filterCode: null,
            defaultValues: [],
            dictionaryType: null,
            availableStatuses: null
          },
          condition: {
            clause: 'LIKE',
            valueData: {
              type: 'StringData',
              id: 0,
              data: searchInn,
              action: null
            }
          },
          complexCondition: null,
          nestedTemplateId: 0,
          nestedFilter: null
        }
      ]

      if (Array.isArray(districtRoles) && districtRoles.length > 0) {
        const districtRolesValueDataList = districtRoles.map(district => ({
          type: 'StringData',
          data: district
        }))

        filters.push({
          attribute: {
            id: 1265,
            code: 'link_dictDistrict',
            dataType: 'LINK',
            attributeType: 'RELATION_DICTIONARY',
            name: 'Район',
            search: true,
            multiple: true,
            filterCode: null,
            defaultValues: null,
            dictionaryType: {
              dictionaryId: 6633,
              dictType: 'DICTIONARY',
              managedGroupId: 0,
              managingDictionaryId: 0
            },
            availableStatuses: null
          },
          condition: {
            clause: 'LIKE',
            valueData: {
              type: 'LinkData',
              id: 0,
              data: null,
              action: null,
              linkedInstanceId: null,
              linkedTemplateId: 0,
              linkedTemplateType: null,
              managedDictionaryGroupId: 0,
              managedDictionaryTemplateId: 0,
              attributes: null
            }
          },
          complexCondition: null,
          nestedTemplateId: 3442,
          nestedFilter: {
            excludeIds: null,
            inboundCondition: null,
            filter: [
              {
                attribute: {
                  id: 4546,
                  code: 'regions_portal_role',
                  dataType: 'STRING',
                  attributeType: 'STRING',
                  name: 'Роль ОМСУ',
                  search: true,
                  multiple: false,
                  filterCode: null,
                  defaultValues: [],
                  dictionaryType: null,
                  availableStatuses: null
                },
                condition: {
                  clause: 'IN',
                  valueData: {
                    type: 'StringData',
                    id: 0,
                    data: null,
                    action: null
                  }
                },
                complexCondition: {
                  clauseList: districtRolesValueDataList.map(() => 'LIKE'),
                  valueDataList: districtRolesValueDataList
                },
                nestedTemplateId: 0,
                nestedFilter: null
              }
            ],
            includeIds: null,
            owner: null,
            shortFormCondition: null
          }
        })
      }

      const payload = {
        tablePageType: {
          menuItemType: {
            id: '3318',
            menuType: 'TEMPLATE'
          },
          offSet: 0,
          pageSize: 10,
          sorts: [
            {
              code: 'id',
              sortDirection: 'DESC'
            }
          ],
          attributesIds: [
            3420,
            1265,
            545,
            543
          ]
        },
        filterType: {
          inboundSearch: false,
          filter: filters
        }
      }

      try {
        const { data } = await plicanteRequestService.post(url, payload)
        return data.tableObjectAttributes?.[0] ?? null
      } catch (e) {
        console.error('Ошибка при поиске организации по ИНН', e)
        return null
      }
    },
    async getInnCode() {
      // ждем, пока getInn появится (до 3 секунд, например)
      let retries = 30
      while (!this.getInn && retries > 0) {
        await new Promise(r => setTimeout(r, 100))
        retries--
      }

      if (!this.getInn) {
        console.warn('ИНН не получен из store — прекращаю запрос')
        return
      }

      this.userInn = await this.getOrgByInn(this.getInn)
    },
    async getOrgNameByInn(searchInn) {
      const org = await this.getOrgByInn(searchInn)

      return org
        ?.attributeValueTypes
        ?.find(attr => attr.id === 543)
        ?.value
        ?.dataList?.[0]
        ?.data ?? ''
    },
    async getOrgByInnByUserDistricts(searchInn) {
      return this.getOrgByInn(searchInn, this.getUserData?.roles || [])
    },
    async fillCurrentFormOrgInfo() {
      this.currentForm.data.date = new Date().toISOString().split('T')[0]
      this.currentForm.data.districtName = this.getUserData.app.district;
      const searchInn = this.currentForm.fields?.find(field => field?.useAsSearchInn)?.value?.trim()
      this.currentForm.data.entName = searchInn ? await this.getOrgNameByInn(searchInn) : this.getOrgName
      this.currentForm.data.entInn = this.getOrgInn
    },
    updatePage(i, code) {
     this.updateDictionary(i, code)
    },
    buildJsonBlobData() {
      const file = JSON.stringify(this.buildFormJsonPayload())
      const base64Json = btoa(
        new TextEncoder().encode(file).reduce((s, b) => s + String.fromCharCode(b), "")
      )

      return {
        name: 'file.json',
        bytes: base64Json,
      }
    },
    buildReportFileData(reportBase64) {
      if (!reportBase64) return null

      if (this.currentForm['excel-name']) {
        const byteChars = atob(reportBase64)
        const byteNums = new Array(byteChars.length)
          .fill(0)
          .map((_, i) => byteChars.charCodeAt(i))
        const byteArray = new Uint8Array(byteNums)

        // const xlsxBlob = new Blob(
        //   [byteArray],
        //   { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
        // )

        return {
          name: this.getExcelName,
          bytes: this.arrayBufferToBase64(byteArray.buffer),
        }
      }

      if (this.currentForm.pdfFileReport) {
        return {
          name: this.getPdfName,
          bytes: reportBase64
        }
      }

      return null
    },
    async buildSignatureData(reportBase64, withSign, selectedThumbprintFromDefaultForm) {
      if (!withSign || !reportBase64) return null

      let selected = this.certList.find(
        c => c.thumbprint === this.selectedThumbprint
      )

      if (!selected && selectedThumbprintFromDefaultForm) {
        selected = selectedThumbprintFromDefaultForm
      }

      if (!selected) return null

      const signature = await signFileWithCert(reportBase64, selected, true)

      return {
        name: 'report.p7s',
        bytes: signature
      }
    },
    applyPrimitiveFieldsToMeta(metaAttributesDataArr, justUpdate) {
      metaAttributesDataArr.forEach(el => {
        if (el.code === this.currentForm.jsonFileReport && !justUpdate) {
          el.valueTypeInstance.dataListInstance = [{
            type: "BlobData",
            data: this.buildJsonBlobData()
          }]
        }

        if (this.currentForm?.fields?.length > 0) {
          const field = this.currentForm.fields.find(f => f.code === el.code)

          if (field) {
            el.valueTypeInstance.dataListInstance = [
              {
                type: "StringData",
                data: field.value,
              }
            ]
          }
        }
      })
    },
    async applyFilesToMeta(metaAttributesDataArr) {
      await Promise.all(
        metaAttributesDataArr.map(async el => {
          if (this.currentForm?.files?.length) {
            const field = this.currentForm.files.find(f => f.code === el.code)

            if (field && field.value && field.value instanceof File) {
              const buffer = await field.value.arrayBuffer()
              const base64 = this.arrayBufferToBase64(buffer)

              el.valueTypeInstance.dataListInstance = [{
                type: "BlobData",
                data: {
                  name: field.value.name,
                  bytes: base64
                }
              }]
            } else if (
              field &&
              field.value &&
              Array.isArray(field.value) &&
              field.value.every(v => v instanceof File)
            ) {
              el.valueTypeInstance.dataListInstance = []

              for (const element of field.value) {
                const buffer = await element.arrayBuffer()
                const base64 = this.arrayBufferToBase64(buffer)

                const file = {
                  type: "BlobData",
                  data: {
                    name: element.name,
                    bytes: base64
                  }
                }

                el.valueTypeInstance.dataListInstance.push(file)
              }
            }
          }
        })
      )
    },
    applySystemFieldsToMeta(metaAttributesDataArr) {
      if (this.currentForm.innField || this.currentForm.period || this.currentForm.reportCode) {
        metaAttributesDataArr.forEach(el => {
          if ([this.currentForm.innField, this.currentForm.period, this.currentForm.reportCode].includes(el.code)) {
            if (el.code === this.currentForm.innField) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.userInn?.id || '',
                type: "LongData",
                action: "CREATE"
              }]
            }

            if (el.code === this.currentForm.period) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.period,
                type: "LongData",
                action: "CREATE"
              }]
            }

            if (el.code === this.currentForm.reportCode) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.currentForm.reportType,
                type: "LongData",
                action: "CREATE"
              }]
            }
          }
        })
      }

      if (this.currentForm.lastYear || this.currentForm.currentYear || this.currentForm.dateReport) {
        metaAttributesDataArr.forEach(el => {
          if ([this.currentForm.lastYear, this.currentForm.currentYear, this.currentForm.dateReport].includes(el.code)) {
            if (el.code === this.currentForm.currentYear) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.currentYear
                  ? this.toTimestamp(this.currentYear)
                  : this.tempDate
                    ? this.toTimestamp(this.tempDate)
                    : null,
                type: "DateData",
              }]
            }

            if (el.code === this.currentForm.lastYear) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.lastYear
                  ? this.toTimestamp(this.lastYear)
                  : this.tempDate
                    ? this.toTimestamp(this.tempDate)
                    : null,
                type: "DateData",
              }]
            }

            if (el.code === this.currentForm.dateReport) {
              el.valueTypeInstance.dataListInstance = [{
                data: this.dateReport
                  ? this.toTimestamp(this.dateReport)
                  : this.tempDate
                    ? this.toTimestamp(this.tempDate)
                    : null,
                type: "DateData",
              }]
            }
          }
        })
      }
    },
    buildObjectInstancePayload(metaAttributesDataArr, { isCreate, instanceId, version }) {
      return {
        objectInstanceRepresentationType: {
          description: this.object?.description || '',
          id: isCreate ? 0 : instanceId,
          version: isCreate ? 0 : version,
          versionDate: isCreate ? null : this.object?.versionDate,
          name: this.object.name,
          templateId: isCreate ? this.currentForm.tableId : this.object.templateId,
          shortForm: null,
          accessType: "ACCESS_FULL",
          templateType: "NONE",
          syncAttributes: [],
          metaAttributesData: metaAttributesDataArr,
          templateCode: null
        },
        getBinaries: true,
        getLinked: false
      }
    },
    async createOrUpdateObject({ payload, withSign, send, pdfBase64FromForm }) {
      if (!this.$route.query.dataId) {
        const instanceId = [
          payload.objectInstanceRepresentationType.id,
          this.$route.query.instanceId,
          this.object?.id
        ]
          .map(value => Number(value))
          .find(value => Number.isFinite(value) && value > 0) || 0

        payload.objectInstanceRepresentationType.id = instanceId

        const operation = instanceId > 0
          ? 'updateObjectInstance'
          : 'createObjectInstance'
        console.log('operation', operation)
        const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/${operation}`

        return plicanteRequestService.post(url, payload)
          .then((data) => {
            if ((withSign && this.currentForm.statusId) || (send && this.currentForm.statusId)) {
              this.onChangeStatus(data.data.id)
            }

            this.$router.push({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                instanceId: data.data.id,
                version: data.data.version,
                attributeId: data.data.metaAttributesData.find(el => el.code == this.currentForm.jsonFileReport)?.attributeId,
                dataId: data.data.metaAttributesData.find(el => el.code == this.currentForm.jsonFileReport)?.valueTypeInstance.dataListInstance[0]?.id
              }
            })

            this.$store.dispatch('success', 'Форма успешно сохранена')
            this.loading = false
          })
          .catch(err => {
            this.snackbar = false
            this.snackbar = true
            this.color = 'red'
            this.text = err.response?.data?.errorMsg || 'Ошибка при сохранении'
            this.loading = false
          })
      }

      return this.saveToPlicante(this.currentForm, withSign, pdfBase64FromForm, send)
    },
   async saveIntoPlicanteObject(withSign, pdfBase64FromForm, selectedThumbprintFromDefaultForm, justUpdate, obj, send) {
    this.loading = true
    this.$store.dispatch('info', 'Отправка формы...')

    const instanceId = [
      this.$route.query.instanceId,
      obj?.id,
      this.object?.id
    ]
      .map(value => Number(value))
      .find(value => Number.isFinite(value) && value > 0) || 0

    const version = [
      this.$route.query.version,
      obj?.version,
      this.object?.version
    ]
      .map(value => Number(value))
      .find(value => Number.isFinite(value) && value >= 0) || 0

    const isCreate = instanceId === 0
    let metaAttributesDataArr = this.metaAttributesData

    const reportFileData = this.buildReportFileData(pdfBase64FromForm)
    const signatureData = await this.buildSignatureData(
      pdfBase64FromForm,
      withSign,
      selectedThumbprintFromDefaultForm
    )

    if (reportFileData && this.currentForm.pdfFileReport) {
      metaAttributesDataArr.forEach(el => {
        if (el.code === this.currentForm.pdfFileReport) {
          const dataList = [
            {
              type: "BlobData",
              data: reportFileData
            }
          ]

          if (withSign && signatureData) {
            dataList.push({
              type: "BlobData",
              data: signatureData
            })
          }

          el.valueTypeInstance.dataListInstance = dataList
        }
      })
    }

    this.applyPrimitiveFieldsToMeta(metaAttributesDataArr, justUpdate)
    await this.applyFilesToMeta(metaAttributesDataArr)
    this.applySystemFieldsToMeta(metaAttributesDataArr)

    this.isPdfMode = false

    const payload = this.buildObjectInstancePayload(metaAttributesDataArr, {
      isCreate,
      instanceId,
      version
    })

    return this.createOrUpdateObject({
      payload,
      withSign,
      send,
      pdfBase64FromForm
    })
    },
    arrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      const chunkSize = 0x8000

      for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize))
      }

      return btoa(binary)
    },
    async saveToPlicante(payloadJson, withSign, pdfBase64FromForm, send) {
      const urlUpload = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/v2/binary-data/upload`;
      // const urlDelete = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/v2/binary-data/delete`

      const instanceId = this.$route.query.instanceId;
      const attributeId = this.$route.query.attributeId;
      let version = this.$route.query.version;
      const dataId = this.$route.query.dataId;

      let meta = null;
      if (this.currentForm.pdfFileReport) {
        if (!this.fullMeta?.length) {
          await this.getMetaAttributes()
        }
        meta = this.fullMeta.find(
          el => el.code?.trim() === this.currentForm.pdfFileReport
        );
      }

      const jsonForm = new FormData();
      
      jsonForm.append("version", version);
      jsonForm.append("instanceId", instanceId);
      jsonForm.append("attributeId", attributeId);
      jsonForm.append("dataId", dataId);

      const json = JSON.stringify(this.buildFormJsonPayload(payloadJson), (key, value) => {
        if (key === 'bytes') {
          return undefined;
        }
        return value;
      });

      const jsonBlob = new Blob([json], {
        type: "application/octet-stream"
      });

      jsonForm.append("file", jsonBlob, "Файл json отчета.json");
      jsonForm.append("name", "report.json");
      jsonForm.append("comment", "string");

      const jsonUploadRes = await fetch(urlUpload, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Authorization": 'Basic ' + btoa(`${localStorage.getItem('token')}` + ':Bearer')
        },
        body: jsonForm
      });

      const jsonUploadData = await jsonUploadRes.json();
      version = jsonUploadData.version || version;
      const newDataId = jsonUploadData.dataId;

      if (this.currentForm?.fields?.length > 0 || this.currentForm?.files?.length > 0) {
        const attrsUpdateData = await this.saveIntoPlicanteObjectAttrs(version);
        version = attrsUpdateData?.version || version;
        if (!this.correctSend) {
          this.$store.dispatch('error', 'Ошибка при сохранении формы');
          this.loading = false;
          return
        }
      }

      if (pdfBase64FromForm && meta) {
        const { blob, filename, mime } = this.base64ToBlobAuto(pdfBase64FromForm);

        const fileUpload = await this.uploadBinaryFile(
          blob,
          filename,
          mime,
          version,
          instanceId,
          meta,
          urlUpload,
          true
        );

        version = fileUpload.version || version;

        if (withSign) {
          const selected = this.certList.find(
            c => c.thumbprint === this.selectedThumbprint
          );

          const base64 = await this.blobToBase64(blob);
          const signatureBlob = await signFileWithCert(base64, selected, true);
          const sigBlob = this.base64ToBlob(signatureBlob);

          const signUpload = await this.uploadBinaryFile(
            sigBlob,
            filename + '.p7s',
            'application/pkcs7-signature',
            version,
            instanceId,
            meta,
            urlUpload
          );

          version = signUpload.version || version;
        }
      }

      if ((withSign && this.currentForm.statusId) || (send && this.currentForm.statusId)) {
        this.onChangeStatus();
      }

      this.refreshMetaAttributes()
      // this.$emit("ongetMetaAttributes");
      this.loading = false
      this.$store.dispatch('success', 'Форма успешно сохранена');
      this.correctSend = false
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          dataId: newDataId,
          version
        }
      });
    },
    async saveIntoPlicanteObjectAttrs(version) {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/updateObjectInstance`

      const fields = this.currentForm?.fields || []
      const fieldMap = Object.fromEntries(fields.map(f => [f.code, f.value]))

      const files = this.currentForm?.files || []
      const filesMap = Object.fromEntries(files.map(f => [f.code, f.value]))

      const emptyFileAttributes = new Set()

      let metaAttributesData = await Promise.all(
        this.metaAttributesData
          .filter(el => el.code in fieldMap || el.code in filesMap)
          .map(async el => {
            const dataList = []

            if (el.code in fieldMap) {
              dataList.push({
                type: "StringData",
                data: fieldMap[el.code] ?? '',
              })
            }

            if (el.code in filesMap) {
              const fileValue = filesMap[el.code]

              if (typeof fileValue === 'string') {
                dataList.push({
                  type: "BlobData",
                  data: fileValue,
                })
              } else if (Array.isArray(fileValue) && fileValue.length === 0) {
                emptyFileAttributes.add(el.code)
              } else if (Array.isArray(fileValue) && fileValue.every(v => v instanceof File || v instanceof Blob)) {
                for (const file of fileValue) {
                  const buffer = await file.arrayBuffer()
                  const base64 = this.arrayBufferToBase64(buffer)

                  dataList.push({
                    type: "BlobData",
                    data: {
                      name: file.name,
                      bytes: base64,
                    }
                  })
                }
              } else if (fileValue instanceof File || fileValue instanceof Blob) {
                const buffer = await fileValue.arrayBuffer()
                const base64 = this.arrayBufferToBase64(buffer)

                dataList.push({
                  type: "BlobData",
                  data: {
                    name: fileValue.name,
                    bytes: base64,
                  }
                })
              } else if (typeof fileValue === 'object'){
                // Файл уже есть на be, не меняем значение атрибута
              } else {
                emptyFileAttributes.add(el.code)
              }
            }

            return {
              ...el,
              valueTypeInstance: {
                ...el.valueTypeInstance,
                dataListInstance: dataList
              }
            }
          })
      )
        metaAttributesData = metaAttributesData.filter(el => {
          const hasData = el.valueTypeInstance.dataListInstance.length > 0
          const isEptyFileAttribute = emptyFileAttributes.has(el.code)

          return hasData || isEptyFileAttribute
        })

        if (metaAttributesData.length === 0) {
          return
        }

      const payload = {
        objectInstanceRepresentationType: {
          description: this.object.description,
          id: this.$route.query.instanceId,
          version: version,
          name: this.object.name,
          templateId: this.currentForm.tableId || this.object.templateId,
          shortForm: null,
          accessType: "ACCESS_FULL",
          templateType: "NONE",
          syncAttributes: [],
          metaAttributesData,
          templateCode: null
        },
        getBinaries: true,
        getLinked: false
      }

      try {
        const data = await plicanteRequestService.post(url, payload)
        this.correctSend = true
        return data.data
        
      } catch (err) {
        this.correctSend = false
        this.snackbar = true
        this.color = 'red'
        this.text = err.response?.data?.errorMsg || 'Ошибка при сохранении'
      }
    },
    getMimeAndExtensionFromBase64(base64) {
      const sig = base64.substring(0, 20);

      if (sig.startsWith("JVBER")) {
        return { mime: "application/pdf", ext: "pdf" };
      }

      if (sig.startsWith("UEsDB")) {
        return { 
          mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          ext: "xlsx"
        };
      }

      return { mime: "application/octet-stream", ext: "bin" };
    },
    base64ToBlobAuto(base64) {
      const byteChars = atob(base64);
      const byteNums = new Array(byteChars.length)
        .fill(0)
        .map((_, i) => byteChars.charCodeAt(i));
      const byteArray = new Uint8Array(byteNums);

      // определяем MIME по сигнатуре
      let mime = "application/octet-stream";
      let filename = "file.bin";

      // PDF — первые байты: 25 50 44 46 ("%PDF")
      if (byteArray[0] === 0x25 && byteArray[1] === 0x50) {
        mime = "application/pdf";
        filename = this.getPdfName;
      }

      // XLSX — zip архив: 50 4B 03 04
      if (
        byteArray[0] === 0x50 &&
        byteArray[1] === 0x4B &&
        byteArray[2] === 0x03 &&
        byteArray[3] === 0x04
      ) {
        mime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        filename = this.getExcelName;
      }

      const blob = new Blob([byteArray], { type: mime });

      return { blob, filename, mime };
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          const result = reader.result
          const base64 = result.split(',')[1]
          resolve(base64)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    async uploadBinaryFile(blob, filename, mimeType, version, instanceId, meta, urlUpload, changeFile) {
      const form = new FormData()
      form.append("version", version)
      form.append("instanceId", instanceId)
      form.append("attributeId", meta.attributeId)
      form.append("file", blob, filename)
      form.append("name", filename)
      form.append("comment", "string")
      if (changeFile && meta.valueTypeInstance.dataListInstance[0]?.id) {
        form.append("dataId", meta.valueTypeInstance.dataListInstance[0]?.id)
      }
      const res = await fetch(urlUpload, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Authorization": 'Basic ' + btoa(`${localStorage.getItem('token')}` + ':Bearer')
        },
        body: form
      })

      return res.json()
    },
    base64ToBlob(base64) {
      let contentType = '';
      let rawBase64 = base64;

      if (base64.includes(';base64,')) {
        const parts = base64.split(';base64,');
        contentType = parts[0].replace('data:', '');
        rawBase64 = parts[1];
      }

      const byteChars = atob(rawBase64);
      const byteNums = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNums[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNums);

      return new Blob([byteArray], { type: contentType });
    },
    async fillExcel(withSign, withoutSign, send, download) {
      if (this.currentForm['server-excel-name']) {
        const url = `${process.env.VUE_APP_BASE_URL}/etl-api/${this.currentForm['server-excel-name']}`
        const json = JSON.stringify(this.currentForm, (key, value) => {
          if (key === 'bytes') {
            return undefined;
          }
          return value;
        });

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: json
        })
        .then(async res => {
          if (!res.ok) {
            throw new Error(`HTTP ${res.status}`)
          }

          const buffer = await res.arrayBuffer()

          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileName =
            this.currentForm['passport-name'] ||
            this.currentForm['server-excel-name'] ||
            'file.xlsx'
          if (download || withSign) {
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(a.href)
          }
          const base64 = this.arrayBufferToBase64(buffer);
          if (withSign) {
            this.saveIntoPlicanteObject(true, base64)
          } else if (withoutSign) {
            this.saveIntoPlicanteObject(false, base64, undefined, undefined, undefined, send)
          }
          return
        })
        .catch(err => {
          alert('Ошибка при скачивании паспорта: ' + err.message)
        })


        return
      }
      try {
        const excelUrl = `${process.env.VUE_APP_BASE_URL}/xlsx-forms-storage/${this.currentForm['excel-name']}`
        const jsonUrl = `${process.env.VUE_APP_BASE_URL}/json-forms-storage/${this.currentForm['json-name']}`

        // 1. Загружаем Excel
        const resExcel = await fetch(excelUrl)
        const buffer = await resExcel.arrayBuffer()
        const workbook = new ExcelJS.Workbook()
        await workbook.xlsx.load(buffer)

        // 2. Загружаем JSON
        const resJson = await requestService.get(jsonUrl)
        this.json = resJson.data
        const dataArr = []

        for (const [key, value] of Object.entries(this.currentForm.data)) {
          dataArr.push({
            id: null,
            field: key,
            value: value
          })
        }

        this.json.data = dataArr;
        this.json.meta.appTitle = this.getUserData?.app?.name;
        this.json.meta.fioDirector = this.getUserData?.lastName + ' ' + this.getUserData?.firstName + ' ' + this.getUserData?.secondName;
        this.json.meta.dateDeparture = this.toDDMMYYYY(new Date())
        this.json.meta.subYear = this.getYear(this.dateReport)
        const filledValues = this.buildValues(this.json)
        // 3. Создаем маппинг $XXX → ячейка
        const cellMap = {}
        workbook.eachSheet(sheet => {
          sheet.eachRow(row => {
            row.eachCell(cell => {
              if (typeof cell.value === "string" && cell.value.trim().startsWith("$")) {
                cellMap[cell.value.trim()] = cell.isMerged ? cell.master.address : cell.address
              }
            })
          })
        })

        // 4. Функция преобразования JS-подобных формул в Excel
        const jsToExcelFormula = (expr) => {
          if (!expr) return ''

          // Заменяем $XXX на адреса ячеек
          expr = expr.replace(/\$[A-Z0-9_]+/g, m => cellMap[m] || m)

          // Math.round -> ROUND(...,0)
          expr = expr.replace(/Math\.round\(([^)]+)\)/g, 'ROUND($1,0)')

          // Сумма через "+"
          if (/\+/.test(expr)) {
            const parts = expr.split('+').map(p => p.trim())
            expr = `SUM(${parts.join(',')})`
          }

          return expr
        }

        // 5. Заполняем вычисляемые формулы
        const formulas = this.json.formulas || {}
        for (const [key, formulaStr] of Object.entries(formulas)) {
          const cellAddress = cellMap[key]
          if (!cellAddress) continue

          let formula = formulaStr

          // Если тернарная конструкция "Если $X = 0, то 0, иначе ..."
          const ternaryMatch = formula.match(/^Если\s+(\$\w+)\s*=\s*0,\s*то\s*0,\s*иначе\s*(.+)$/i)
          if (ternaryMatch) {
            const checkCell = cellMap[ternaryMatch[1]] || ternaryMatch[1]
            let expr = ternaryMatch[2]
            expr = jsToExcelFormula(expr)
            formula = `IF(${checkCell}=0,0,${expr})`
          } else {
            formula = jsToExcelFormula(formula)
          }

          formula = `IFERROR(${formula},"")`

          workbook.eachSheet(sheet => {
            if (sheet.getCell(cellAddress)) {
              sheet.getCell(cellAddress).value = { formula }
            }
          })
        }

        // 6. Заполняем обычные и дефолтные значения
        workbook.eachSheet(sheet => {
          sheet.eachRow(row => {
            row.eachCell(cell => {
              if (typeof cell.value === "string") {
                let newVal = cell.value.replace(/\$[A-Za-z0-9_]+/g, match => {
                  return filledValues[match] !== undefined ? filledValues[match] : match
                })

                // если newVal — чистое число, сохраняем как число
                if (/^-?\d+(\.\d+)?$/.test(newVal)) {
                  cell.value = Number(newVal)
                } else {
                  cell.value = newVal === 'null' ? '' : newVal
                }
              }
            })
          })
        })

        // 7. Сохраняем и скачиваем
        const outBuffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([outBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

        const xlsxBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result.split(',')[1]) // чистая base64-строка
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })

        if (download || withSign) {
          const url = URL.createObjectURL(blob)
          const a = document.createElement("a")
          a.href = url
          a.download = this.currentForm['excel-name'] || "filled.xlsx"
          a.click()
          URL.revokeObjectURL(url)
        }

        if (withSign) {
          this.saveIntoPlicanteObject(true, xlsxBase64)
        } else if (withoutSign) {
          this.saveIntoPlicanteObject(false, xlsxBase64, undefined, undefined, undefined, send)
        }

      } catch (err) {
        console.error("Ошибка при заполнении Excel:", err)
      }
    },
    
    updateObject(obj) {
      this.object = obj
    },
    buildValues(json) {
      const { meta, data, mapping, defaultValues } = json
      const values = {}

      data.forEach(({ field, value }) => {
        if (mapping[field]) {
          values[mapping[field]] = value
        }
      })

      for (const [key, value] of Object.entries(meta)) {
        if (mapping[key]) {
          let val = value
          if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
            const [y, m, d] = val.split('-')
            val = `${d}.${m}.${y}`
            values[mapping[key]] = val
          }
          values[mapping[key]] = val
        }
      }
      // 3. Добавляем дефолтные значения
      return Object.assign(values, defaultValues)
    },
    async wordToJson() {
      try {
        const res = await fetch('/doc.docx')
        const file = await res.arrayBuffer()

        const zip = await JSZip.loadAsync(file)
        const docXml = await zip.file("word/document.xml").async("string")

        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(docXml, "application/xml")

        const tbls = [...xmlDoc.getElementsByTagName("w:tbl")]
        const parsedTables = tbls.map(tbl => {
          const rows = [...tbl.getElementsByTagName("w:tr")]
          return rows.map(tr => {
            const cells = [...tr.getElementsByTagName("w:tc")]
            return cells.map(tc => {
              const texts = [...tc.getElementsByTagName("w:t")]
              return texts.map(t => t.textContent).join(" ")
            })
          })
        })

        // ---- обычные значения ----
        const usualValues = parsedTables[0].slice(1)
        const usualValuesWithKeys = {}
        const defaultValuesWithKeys = {}

        usualValues.forEach(row => {
          const [key, val, defaultVal] = row
          if (key && key.trim() !== "") {
            usualValuesWithKeys[key] = val
          } else if (defaultVal && defaultVal.trim() !== "") {
            defaultValuesWithKeys[val] = defaultVal
          }
        })

        // ---- вычисляемые значения ----
        // const calcValues = parsedTables[1].slice(1)
        // const calcValuesWithKeys = Object.fromEntries(
        //   calcValues.map(([key, desc]) => {
        //     let value = desc

        //     // Если тернарное выражение
        //     // const ternaryMatch = value.match(/^Если\s+(\$\w+)\s*=\s*0,\s*то\s*0,\s*иначе\s*(.+)$/i)
        //     // if (ternaryMatch) {
        //     //   value = ternaryMatch[2].trim()
        //     // }

        //     // "Сумма всех $X" -> all $X
        //     if (/^Сумма всех (\$\w+)/i.test(value)) {
        //       value = value.replace(/^Сумма всех (\$\w+)/i, 'all $1')
        //     }

        //     // "Сумма $X, $Y, $Z" или "сумма $X + $Y" или смешанное
        //     else if (/^Сумма\s+/i.test(value)) {
        //       let str = value.replace(/^Сумма\s+/i, '')
        //       const vars = str.split(/[,+\s]+/).filter(v => v)
        //       value = vars.join(' + ')
        //     }


        //     // округление
        //     if (/\(округление до целых\)$/.test(value) || /\(округляется до целых\)$/.test(value)) {
        //       value = value
        //         .replace(/\(округление до целых\)$/, '')
        //         .replace(/\(округляется до целых\)$/, '')
        //         .trim()
        //       value = `Math.round(${value})`
        //     }

        //     return [key, value]
        //   })
        // )

        // ---- заменяем valueXXX на $XXX в defaultValues ----
        for (const [key, val] of Object.entries(defaultValuesWithKeys)) {
          let newVal = val

          // Заменяем "сумма valueXXX, valueYYY, ..." или "valueXXX + valueYYY"
          const vars = newVal.split(/[,+]/).map(v => v.trim()).filter(v => v)
          newVal = vars.map(v => usualValuesWithKeys[v] || v).join(' + ')

          defaultValuesWithKeys[key] = +(newVal)
        }

      } catch (err) {
        console.error("Ошибка при загрузке или парсинге Word:", err)
      }
    },
    getTabTitle(group) {
      return group[0]?.name || 'Раздел';
    },
    getAllForms() {
      const url = `${process.env.VUE_APP_BASE_URL}/forms-storage/forms-index.json`;
      requestService.get(url)
      .then(responce => {
        const foundForm = responce.data.find(form => form.id === this.$route.query.id);
        if (foundForm) {
          this.getFoundForm(foundForm.formJsonUrl)
        } else {
          this.error = true;
          this.errorMessage = 'Указанная форма не найдена'
        }
      })
      .catch(err => {
        console.log(err)
        this.error = true;
      })
    },
    getFoundForm(formJsonUrl) {
      const url = `${process.env.VUE_APP_BASE_URL}${formJsonUrl}`;
      requestService.get(url)
      .then(responce => {
        this.currentForm = responce.data;
        this.currentFormDefaultData = responce.data.data;
        this.restoreMapPoints(this.currentForm.points || [])
        if (responce.data.readonlyStatuses) {
          this.readonlyStatuses = responce.data.readonlyStatuses;
        } else {
          this.readonlyStatuses = []
        }
        // if (this.currentForm.saveIntoPlicanteObject) {
        //   this.getMetaAttributes() 
        // }
        this.getMetaAttributes() 

        // Пользователь открыл ранее созданный отчёт
        if (this.$route.query.dataId) {
          this.getPlicanteData()
        } 

        // Пользователь создал новый отчёт, подтягиваем данные последнего отчёта
        else if (this.currentForm.findFirst) {
          this.getFirstOfType()
        }
      })
      .catch(err => {
        this.error = true;
        console.log(err)
      })
    },
    getFirstOfType() {
      if (!this.getOrgInn){
        console.log("Нет ИНН, не запрашиваем последний отчёт")
        return
      }
      if (!this.currentForm.innField){
        console.log("Не указан атрибут ИНН, не запрашиваем последний отчёт")
        return
      }

      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`;

      // Нужен только последний созданный отчёт, запрашиваем один отчёт с наибольшим id
      const payload = {
        tablePageType: {
          menuItemType: {
            id: this.currentForm.tableId,
            menuType: "TEMPLATE"
          },
          offSet: -1,
          pageSize: "1",
          sorts: [
            { code: "id", sortDirection: "DESC" }
          ]
        },
        filterType: {
          inboundSearch: false,
          filter: []
        }
      };

      const withInn = {
          "attribute": {
              "id": null,
              "code": this.currentForm.innField,
              "dataType": "LINK",
              "attributeType": "RELATION",
              "name": null,
              "search": true,
              "multiple": false,
              "filterCode": null,
              "defaultValues": null,
              "dictionaryType": null,
              "availableStatuses": null
          },
          "condition": {
              "clause": "LIKE",
              "valueData": {
                  "type": "LinkData",
                  "id": 0,
                  "data": null,
                  "action": null,
                  "linkedInstanceId": null,
                  "linkedTemplateId": 0,
                  "linkedTemplateType": null,
                  "managedDictionaryGroupId": 0,
                  "managedDictionaryTemplateId": 0,
                  "attributes": null
              }
          },
          "complexCondition": null,
          "nestedTemplateId": 3318,
          "nestedFilter": {
              "excludeIds": null,
              "inboundCondition": null,
              "filter": [
                  {
                      "attribute": {
                          "id": 545,
                          "code": "inn",
                          "dataType": "STRING",
                          "attributeType": "STRING",
                          "name": "ИНН",
                          "search": true,
                          "multiple": false,
                          "filterCode": null,
                          "defaultValues": [],
                          "dictionaryType": null,
                          "availableStatuses": null
                      },
                      "condition": {
                          "clause": "LIKE",
                          "valueData": {
                              "type": "StringData",
                              "id": 0,
                              "data": this.getOrgInn,
                              "action": null
                          }
                      },
                      "complexCondition": null,
                      "nestedTemplateId": 0,
                      "nestedFilter": null
                  }
              ],
              "includeIds": null,
              "owner": null,
              "shortFormCondition": null
          }
      }

      payload.filterType.filter.push(withInn)

      if (this.currentForm.reportCode){
        const reportType = {
              attribute: {
                id: 892,
                code: this.currentForm.reportCode,
                dataType: "LINK",
                attributeType: "RELATION_DICTIONARY",
                name: "Вид отчета",
                search: true,
                multiple: false,
                filterCode: null,
                defaultValues: null,
                dictionaryType: {
                  dictionaryId: 5591,
                  dictType: "DICTIONARY",
                  managedGroupId: 0,
                  managingDictionaryId: 0
                }
              },
              condition: {
                clause: "EQUALS",
                valueData: {
                  type: "LinkData",
                  id: 0,
                  linkedInstanceId: [this.currentForm.reportType]
                }
              },
              nestedTemplateId: 5591
            }

        payload.filterType.filter.push(reportType)
      }
      
      plicanteRequestService.post(url, payload)
        .then(res => {
          const arr = res?.data?.tableObjectAttributes || [];

          if (!arr.length) {
            console.log("Нет ранее поданных отчётов, не предзаполняем новый отчёт")
            return
          }

          const reportObj = arr[0];
          const report = (reportObj.attributeValueTypes || []).find(
            el => el.code === this.currentForm.jsonFileReport
          );
          const fileId = report?.value?.dataList?.[0]?.id;

          if (fileId) {
            this.getPlicanteData(fileId);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPlicanteData(dataId) {
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/v2/binary-data/download/${dataId ? dataId : this.$route.query.dataId}`
      plicanteRequestService.get(url)
      .then(data => {

        if (dataId) {
          this.currentForm.data = {
            ...this.currentFormDefaultData,
            ...data.data.data
          };
          this.restoreMapPoints(data.data.points || [])
          return
        }

        if (data.data.data) {
          if (data.data.sections) {
            this.currentForm = data.data
            this.restoreMapPoints(this.currentForm.points || [])
          }
        } else if (data.data) {
          data.data.forEach(item => {
            if (item.value != null) {
              this.currentForm.data[item.field] = isNaN(item.value) ? item.value : Number(item.value)
            }
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    refreshMetaAttributes() {
      return this.getMetaAttributes({ force: true })
    },
    async getMetaAttributes({ force = false } = {}) {
      const requestKey = JSON.stringify({
        templateId: +(this.currentForm.journalId || this.currentForm.tableId),
        instanceId: +(this.$route.query.objectId || this.$route.query.instanceId || 0)
      })

      if (
        this.metaAttributesRequest &&
        this.metaAttributesRequestKey === requestKey
      ) {
        return this.metaAttributesRequest
      }

      if (!force && this.metaAttributesLoadedKey === requestKey) {
        return this.object
      }

      const request = this.loadMetaAttributes()
      this.metaAttributesRequest = request
      this.metaAttributesRequestKey = requestKey

      try {
        const result = await request

        if (result) {
          this.metaAttributesLoadedKey = requestKey
        }

        return result
      } finally {
        if (this.metaAttributesRequest === request) {
          this.metaAttributesRequest = null
          this.metaAttributesRequestKey = null
        }
      }
    },
    async loadMetaAttributes() {
      const payload = {
        instanceType: {
          templateId: +(this.currentForm.journalId || this.currentForm.tableId),
          id: this.$route?.query?.instanceId || 0
        },
        typeNode: {
          nodeType: "DETAILED_FORM_VIEW"
        },
        getLinked: false
      }

      if (this.$route.query.objectId) {
        payload.instanceType.id = this.$route.query.objectId
      }

      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/formViewTemplate/search`

      try {
        const data = await plicanteRequestService.post(url, payload)

        this.metaAttributesData = data.data.metaAttributesData

        if ((this.currentForm.innField || this.currentForm.period) && this.metaAttributesData) {
          this.metaAttributesData.forEach(el => {
            if (el.code == this.currentForm.innField || el.code == this.currentForm.period) {
              this.getItemsForDictionary(el, el.code)
            }
          })
        }

        this.object = data.data

        if (this.$route.query.instanceId && this.metaAttributesData) {
          let attributesIds = []

          this.metaAttributesData.forEach(el => {
            attributesIds.push(el.attributeId)
          })

          const innerPayload = {
            instanceType: {
              templateId: +(this.currentForm.tableId),
              id: +(this.$route.query.instanceId),
              attributesIds: attributesIds,
              attributesOnly: true
            },
            typeNode: {
              nodeType: "DETAILED_FORM_VIEW"
            },
            getLinked: true,
            getBinaries: false
          }

          const innerUrl = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/objectRepresentation/search`

          try {
            const innerData = await plicanteRequestService.post(innerUrl, innerPayload)

            this.metaAttributesData = innerData.data.metaAttributesData
            this.fullMeta = JSON.parse(JSON.stringify(innerData.data.metaAttributesData))

            if (this.currentForm?.fields && this.currentForm.fields.length > 0) {
              this.currentForm.fields.forEach(field => {
                const meta = this.metaAttributesData.find(m => m.code?.trim() === field.code?.trim())
                if (meta) {
                  if (meta.valueTypeInstance.dataListInstance[0]?.data) {
                    field.value = meta.valueTypeInstance.dataListInstance[0]?.data
                  }
                  field.value = meta.valueTypeInstance.dataListInstance[0]?.data
                }
              })
            }

            if (this.currentForm?.files && this.currentForm.files.length > 0) {
              this.currentForm.files.forEach(field => {
                const meta = this.metaAttributesData.find(m => {
                  return m.code?.trim() === field.code?.trim()
                })

                if (meta) {
                  const dataListInstance = meta.valueTypeInstance?.dataListInstance || []

                  if (field.multiple) {
                    field.value = dataListInstance
                      .filter(el => el.type === 'BlobData')
                      .map(el => el.data)
                  } else {
                    field.value = dataListInstance.find(el => el.type === 'BlobData')?.data || null
                  }
                }
              })
            }

            if (this.currentForm.currentYear) {
              const metaData = innerData.data.metaAttributesData.find(el => el.code == this.currentForm.currentYear)
              if (metaData && metaData.valueTypeInstance.dataListInstance[0]?.data) {
                this.currentYear = metaData.valueTypeInstance.dataListInstance[0].data
              }
            }

            if (this.currentForm.lastYear) {
              const metaData = innerData.data.metaAttributesData.find(el => el.code == this.currentForm.lastYear)
              if (metaData && metaData.valueTypeInstance.dataListInstance[0]?.data) {
                this.lastYear = metaData.valueTypeInstance.dataListInstance[0].data
              }
            }

            if (this.currentForm.dateReport) {
              const metaData = innerData.data.metaAttributesData.find(el => el.code == this.currentForm.dateReport)
              if (metaData && metaData.valueTypeInstance.dataListInstance[0]?.data) {
                this.dateReport = metaData.valueTypeInstance.dataListInstance[0].data
              }
            }

            if (this.currentForm.period) {
              const metaData = innerData.data.metaAttributesData.find(el => el.code == this.currentForm.period)
              if (metaData && metaData.valueTypeInstance.dataListInstance[0]?.data) {
                this.period = metaData.valueTypeInstance.dataListInstance[0].data.memberId
              }
            }

            this.currentForm.sections?.forEach(section => {
              section?.fields?.forEach(field => {
                const meta = this.metaAttributesData.find(m => m.code?.trim() === field.code?.trim())
                if (meta) {
                  if (meta.attributeType === 'RELATION_DICTIONARY' || meta.attributeType === "RELATION_REVERSE") {
                    this.currentForm.data[field.name] = meta.valueTypeInstance?.dataListInstance?.length > 0
                      ? meta.valueTypeInstance.dataListInstance[0].attributes
                      : []

                    if (meta.valueTypeInstance?.dataListInstance?.length > 0) {
                      field.oldValue = meta.valueTypeInstance.dataListInstance[0].attributes
                    }
                  }

                  if (
                    meta.attributeType == 'STRING' ||
                    meta.attributeType == 'DOUBLE' ||
                    meta.attributeType == 'BOOLEAN' ||
                    meta.attributeType == 'LONG'
                  ) {
                    this.currentForm.data[field.name] = meta.valueTypeInstance?.dataListInstance[0]
                      ? meta.valueTypeInstance?.dataListInstance[0].data
                      : ''

                    if (meta.valueTypeInstance?.dataListInstance[0]) {
                      field.oldValue = meta.valueTypeInstance?.dataListInstance[0].data
                    }
                  }
                }
              })
            })
          } catch (err) {
            console.log(err)
          }
        }

        data.data.metaAttributesData.forEach(el => {
          if (el.attributeType == 'RELATION_DICTIONARY' || el.attributeType == 'RELATION_REVERSE') {
            this.getItemsForDictionary(el, el.code)
          }
        })

        return data.data
      } catch (err) {
        console.log(err)
        return null
      }
    },
    updateDictionary(i, code) {
      const el = this.metaAttributesData.find(el => el.code.trim() == code.trim());
      this.getItemsForDictionary(el, code, i)
    },
    getItemsForDictionary(el, code, offSet = 0, memberId) {
      let id = el.valueTypeInstance.dataListTemplate[0].data.memberId
      if (el.attributeType == "RELATION_REVERSE") {
        id = el.valueTypeInstance.dataListTemplate[0].data.ownerId
      }
      const payload = {
        "tablePageType": {
          "menuItemType": {
            "id": memberId ? memberId : id              
            },
            "offSet": offSet,
            "pageSize": 10,
            "getLinkedWithOwner": "true"
        },
        "filterType": {
          "owner": {
              "templateId": 79909,
          }
        }
      }
      const url = `${process.env.VUE_APP_BASE_URL}/register-rest/operator/countedTableAttributes/search`
      plicanteRequestService.post(url, payload)
      .then(data => {
        data.data.tableObjectAttributes = data.data.tableObjectAttributes.filter(el => el.shortForm.length > 0)
        this.distionaryItems[code.trim()] =[{shortForm: '--', id: null}, ...data.data.tableObjectAttributes]
        this.distionaryItemsLength[code.trim()] = Math.ceil(data.data.count / 10);
        this.distionaryItemsOffSet[code.trim()] = offSet;
      })
      .catch(err => {
        console.log(err)
      })
    },
    getDefaultValues() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/${this.currentForm.defaultValuesUrl}?id=${this.$route.query.reportId}`
      requestService.get(url)
      .then(data => {
        if (this.currentForm.mapDefaultValues) {
          this.currentForm.mapDefaultValues.forEach(el => {
            if (this.currentForm.data[Object.keys(el)] && data.data[Object.values(el)]) {
              this.currentForm.data[Object.keys(el)] = data.data[Object.values(el)]
            }
          })
        }
        this.currentForm.data.value1 = data.data.directionTitle;
        this.currentForm.data.value7 = data.data.nAmount;
      })
      .catch(err => {
        console.log(err)
      })
    },
    getFormData() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/${this.currentForm.formDataUrl}?id=${this.$route.query.reportId}`
      requestService.get(url)
      .then(data => {
        ///111
        this.meta = data.data.meta;
        this.meta.appTitle = this.getUserData?.app?.name;
        this.meta.fioDirector = this.getUserData?.lastName + ' ' + this.getUserData?.firstName + ' ' + this.getUserData.secondName;
        this.meta.dateDeparture = this.toDDMMYYYY(new Date())
        this.subYear = this.getYear(this.dateReport)
        if (data?.data?.data?.length == 0) {
          this.getDefaultValues()
        } else {
          data?.data?.data.forEach(item => {
            if (item.value != null) {
              this.currentForm.data[item.field] = isNaN(item.value) ? item.value : Number(item.value)
            }
          })
        } 
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    ...mapGetters(['getInn', 'getUserData', 'userIsOmsu']),
    isLastTab(){
      return this.groupedSections?.length <= 1 || this.activeTab === this.groupedSections.length - 1
    },
    formattedMapArea() {
      if (this.mapPoints.length < 3) return '—'

      const hectares = this.mapAreaSquareMeters / 10_000

      return `${hectares.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      })} га`
    },
    isSubmittingForOtherOrg() {
      return this.currentForm?.submitForOtherOrg && this.userIsOmsu
    },
    isInnValid() {
      if (!this.inn) return false
      if (this.innError) return false
      return this.innRule(this.inn) === true
    },
    getOrgInn(){
      if (this.$route.query.dataId && this.currentForm?.data?.entInn) {
          return this.currentForm?.data?.entInn
        }
      return (this.isSubmittingForOtherOrg ? this.enteredInn : this.getInn) || null
    },
    getOrgName(){
      if (this.$route.query.dataId && this.currentForm?.data?.entName) {
          return this.currentForm?.data?.entName
        }
      return (this.isSubmittingForOtherOrg ? this.enteredInnName : this.getUserData?.app?.name) || null
    },
    allFilesValid() {
      if (!this.currentForm?.files?.length) return true

      return this.currentForm.files.every(field => {
        return this.validateFileValue(field)
      })
    },
    allRequiredTableFieldsFilled() {
      if (!this.currentForm?.sections) return true

      return this.currentForm.sections
        .filter(section => section.type === 'table')
        .flatMap(section => section.rows || [])
        .filter(row => row.cells)
        .flatMap(row => Object.values(row.cells))
        .every(cell => {
          if (!cell?.required || this.isTableCellDisabled(cell)) return true
          const value = this.currentForm.data[cell.name]
          if (value === undefined || value === null || String(value).trim() === '') return false
          return cell.type !== 'date' || !isNaN(new Date(value).getTime())
        })
    },
    getReportName() {
      const date = new Date().toISOString().split('T')[0]

      const name = this.getOrgName || ''
      const inn = this.getOrgInn || ''

      const safeName = name
        .replace(/[^\p{L}\p{N}]+/gu, '_')
        .replace(/^_+|_+$/g, '')

      return `${safeName}_${inn}_${date}`
    },
    getExcelName() {
      return `${this.getReportName}.xlsx`
    },
    getPdfName() {
      return `${this.getReportName}.pdf`
    },
    allRequiredFilesFilled() {
      if (!this.currentForm?.files?.length) return true

      return this.currentForm.files.every(field => {
        if (!field.required) return true

        if (!field.value) return false

        if (Array.isArray(field.value)) {
          return field.value.length > 0
        }

        return true
      })
    },
    calcAllItems() {
      const result = this.groupedSections[0].flatMap(obj => obj.rows)
      return result
    },
    renderedHtmlTitle() {
      if (!this.currentForm || !this.currentForm.title) return '';

      const data = this.currentForm.data || {};

      return this.currentForm.title.replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
        return data[key] != null ? data[key] : '';
      });
    },
    groupedSections() {
      const groups = new Map();
      const sections = this.currentForm?.sections || [];

      sections.forEach(section => {
        const key = section.pairId != null ? section.pairId : Symbol(); 
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(section);
      });

      return Array.from(groups.values());
    },
    allRequiredFieldsFilled() {
      const section = this.currentForm.sections[this.activeTab];

      if (section.type !== 'table') return true;

      const requireAll = section.requireModel === 'all';

      return section.rows
        .filter(row => row.cells)
        .flatMap(row => Object.values(row.cells))
        .filter(cell =>
          ['text-input', 'date', 'select', 'checkbox', 'number-input'].includes(cell.type) &&
          (requireAll || cell.required)
        )
        .every(cell => {
          const value = this.currentForm.data[cell.name];
          if (cell.type === 'select') {
            return value !== undefined && value !== null && value !== '';
          }
          if (cell.type === 'date') {
            return !!value && !isNaN(new Date(value).getTime());
          }
          return value !== undefined && value !== null && String(value).trim() !== '';
      });
    }
  },
  mounted() {
    this.getAllForms();
    this.getInnCode()

    // try {
    //   if (typeof forms === 'undefined' || !Array.isArray(forms)) {
    //     console.log('Формы не загружены или отсутствуют');
    //     return;
    //   }

      // const foundForm = forms.find(form => form.id === this.$route.query.id);
      // if (foundForm) {
      //   this.currentForm = foundForm;
      // } else {
      //   console.warn('Форма с таким id не найдена');
      // }

    // } catch (error) {
    //   console.error('Ошибка при загрузке формы:', error);
    // }
  },
  beforeUnmount() {
    this.destroyMap()
  }

  };
</script>

<style lang="css" scoped>

  .map-button {
    min-height: 46px;
    padding-inline: 18px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.01em;
    text-transform: none;
    background: linear-gradient(135deg, #26a69a 0%, #00897b 100%);
    box-shadow: 0 8px 18px rgba(0, 137, 123, 0.24) !important;
    transition: transform 180ms ease, box-shadow 180ms ease;
  }

  .map-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 11px 24px rgba(0, 137, 123, 0.32) !important;
  }

  .map-button:active {
    transform: translateY(0);
  }

  .map-dialog-card {
    overflow: hidden;
  }

  .map-dialog-header {
    min-height: 64px;
    border-bottom: 1px solid var(--app-border);
  }

  .map-search {
    border-bottom: 1px solid var(--app-border);
    background: #fff;
  }

  .map-search__field {
    min-width: 0;
  }

  .map-search__button {
    min-height: 40px;
  }

  .map-search__error {
    color: var(--app-error);
    font-size: 13px;
  }

  .map-toolbar {
    border-bottom: 1px solid var(--app-border);
    background: rgba(0, 137, 123, 0.06);
  }

  .map-stat {
    display: flex;
    flex-direction: column;
    min-width: 90px;
  }

  .map-stat__label,
  .map-hint {
    color: var(--app-text-muted);
    font-size: 12px;
  }

  .map-hint {
    border-top: 1px solid var(--app-border);
  }

  .leaflet-map {
    width: 100%;
    height: min(68vh, 640px);
    min-height: 360px;
    cursor: crosshair;
  }

  .leaflet-map :deep(.map-point-marker) {
    display: grid;
    place-items: center;
    border-radius: 50%;
    border: 2px solid #fff;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    background: #00897b;
    box-shadow: 0 2px 8px rgba(0, 69, 62, 0.4);
    cursor: grab;
  }

  .leaflet-map :deep(.map-point-marker:active) {
    cursor: grabbing;
    transform: scale(1.12);
  }

  .leaflet-map :deep(.map-delete-leaflet-popup .leaflet-popup-content-wrapper) {
    border: 1px solid rgba(0, 137, 123, 0.22);
    border-radius: 14px;
    box-shadow: 0 8px 24px rgba(0, 105, 92, 0.22);
  }

  .leaflet-map :deep(.map-delete-leaflet-popup .leaflet-popup-content) {
    width: auto !important;
    min-width: 210px;
    margin: 16px;
  }

  .leaflet-map :deep(.map-delete-leaflet-popup .leaflet-popup-tip) {
    box-shadow: 2px 2px 4px rgba(0, 105, 92, 0.12);
  }

  .leaflet-map :deep(.map-delete-popup__question) {
    margin-bottom: 14px;
    color: #263238;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
  }

  .leaflet-map :deep(.map-delete-popup__actions) {
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .leaflet-map :deep(.map-delete-popup__button) {
    min-width: 88px;
    min-height: 40px;
    padding: 9px 16px;
    border: 0;
    border-radius: 9px;
    font: inherit;
    font-weight: 600;
    cursor: pointer;
    transition: transform 150ms ease, filter 150ms ease;
  }

  .leaflet-map :deep(.map-delete-popup__button--cancel) {
    color: #00695c;
    background: #d8f3ee;
  }

  .leaflet-map :deep(.map-delete-popup__button--delete) {
    color: #fff;
    background: #00897b;
  }

  .leaflet-map :deep(.map-delete-popup__button:hover) {
    filter: brightness(0.94);
    transform: translateY(-1px);
  }

  .subtitle, .header {
    color: var(--app-text-muted);
    font-size: 24px;
  }

  .areaName {
    color: var(--app-text);
    font-size: 15px;
  }
  
  .header {
    color: var(--app-text);
  }

::v-deep(.v-data-table thead th) {
  border-bottom: 1px solid var(--app-border);
  border-top: 1px solid var(--app-border);
  border-left: 1px solid var(--app-border);
  padding: 8px;

}
::v-deep(.v-data-table thead th .v-data-table-header__content) {
  font-weight: bold;
  display: flex;
  justify-content: center;
}

::v-deep(.v-data-table thead th:last-child) {
  border-right: 1px solid var(--app-border);
}

::v-deep(.v-table--density-default) {
  --v-table-header-height: 38px
}

.pdf-mode::v-deep(.v-table__wrapper) {
  overflow: visible !important;
  max-height: none !important;
}

.pdf-mode::v-deep(.custom-bordered-table) {
  height: auto !important;
}

.pdf-mode::v-deep(.custom-bordered-table thead) {
  position: static !important;
  top: auto !important;
}

.cert-valid {
  color: var(--app-success);
}

.cert-invalid {
  color: var(--app-error);
}

@media (max-width: 480px) {
  .map-search > .d-flex {
    flex-direction: column;
    align-items: stretch !important;
  }

  .map-search__field,
  .map-search__button {
    width: 100%;
  }

  .universal-form:not(.pdf-mode) {
    padding: 10px !important;
  }

  .universal-form:not(.pdf-mode) .header {
    font-size: clamp(18px, 6vw, 22px) !important;
    line-height: 1.3;
    overflow-wrap: anywhere;
  }

  .universal-form:not(.pdf-mode) .organization-info {
    flex-direction: column;
  }

  .universal-form:not(.pdf-mode) .organization-info .subtitle {
    margin-left: 0 !important;
    margin-bottom: 8px !important;
    font-size: 17px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .universal-form:not(.pdf-mode) .report-meta {
    flex-direction: column;
  }

  .universal-form:not(.pdf-mode) .report-meta > .areaName {
    width: 100%;
    min-width: 0;
    margin-right: 0 !important;
  }

  .universal-form:not(.pdf-mode) .report-meta > .areaName > div {
    width: 100%;
    min-width: 0;
  }

  .universal-form:not(.pdf-mode) .report-meta :deep(.v-input),
  .universal-form:not(.pdf-mode) .report-files :deep(.v-input),
  .universal-form:not(.pdf-mode) > .mb-5 :deep(.v-input) {
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
    margin-left: 0 !important;
  }

  .universal-form:not(.pdf-mode) .report-meta :deep(.v-btn) {
    width: 100% !important;
    min-height: 44px;
  }

  .universal-form:not(.pdf-mode) .additional-fields,
  .universal-form:not(.pdf-mode) .additional-fields__list {
    width: 100%;
    flex-direction: column;
  }

  .universal-form:not(.pdf-mode) .additional-fields__list > div {
    width: 100%;
  }

  .universal-form:not(.pdf-mode) .additional-fields__list p,
  .universal-form:not(.pdf-mode) .report-files p {
    margin-left: 0 !important;
    overflow-wrap: anywhere;
  }

  .universal-form:not(.pdf-mode) :deep(.v-tabs) {
    max-width: 100%;
  }

  .universal-form:not(.pdf-mode) :deep(.v-tab) {
    min-width: min(180px, 72vw);
    max-width: 72vw;
    padding-inline: 12px;
    white-space: normal;
  }

  .universal-form:not(.pdf-mode) .report-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .universal-form:not(.pdf-mode) .report-actions > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .universal-form:not(.pdf-mode) .report-actions :deep(.v-btn) {
    width: 100%;
    min-height: 44px;
    height: auto;
    margin-right: 0 !important;
    white-space: normal;
  }

  :deep(.v-dialog .v-list-item-title),
  :deep(.v-dialog .v-list-item-subtitle) {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}

</style>
